@if (window.globalActiveUser) {

    @if (item.navCap) {
        <div mat-subheader class="nav-caption">
            {{ item.navCap }}
        </div>
    }
    
    @if (!item.navCap && !item.external && !item.twoLines && checkPermission(item) && checkExistHaveOrganisation(item) == true) {
        <a
                mat-list-item
                (click)="onItemSelected(item)"
                [ngClass]="{
    'mat-toolbar mat-primary activeMenu': item.route
      ? router.isActive(item.route, true)
      : false,
    expanded: expanded,
    disabled: item.disabled
  }"
                class="menu-list-item"
        >
            <ng-container *ngIf="!item.customIcon">
                <i-tabler
                        class="routeIcon"
                        name="{{ item.iconName }}"
                        matListItemIcon
                ></i-tabler>
            </ng-container>
            <ng-container *ngIf="item.customIcon">
                <img *ngIf="themeService.getCurrentTheme() !== 'dark'" [src]="item.customIcon" alt="icon" class="icon-20 align-middle" matListItemIcon>
                <img *ngIf="themeService.getCurrentTheme() === 'dark' && item.customIconDark" [src]="item.customIconDark" alt="icon"
                     class="icon-20 align-middle" matListItemIcon>
                <img *ngIf="themeService.getCurrentTheme() === 'dark' && !item.customIconDark" [src]="item.customIcon" alt="icon"
                     class="icon-20 align-middle" matListItemIcon>
            </ng-container>
            <span class="hide-menu">{{ item.displayName | localize }}</span>
            @if (item.children && item.children.length) {
                <span class="arrow-icon" fxFlex>
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
            }
            @if (item.chip) {
                <span>
    <span
            class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill "
    >{{ item.chipContent }}</span
    >
  </span>
            }
        </a>
    }

    <!-- external Link -->

    @if (!item.navCap && item.external && checkPermission(item) && checkExistHaveOrganisation(item) == true) {
        <mat-list-item
                onClick="window.open('//google.com')"
                class="menu-list-item"
                target="_blank"
        >
            <ng-container *ngIf="!item.customIcon">
                <i-tabler
                        class="routeIcon"
                        name="{{ item.iconName }}"
                        matListItemIcon
                ></i-tabler>
            </ng-container>
            <ng-container *ngIf="item.customIcon">
                <img *ngIf="themeService.getCurrentTheme() !== 'dark'" [src]="item.customIcon" alt="icon" class="icon-20 align-middle" matListItemIcon>
                <img *ngIf="themeService.getCurrentTheme() === 'dark' && item.customIconDark" [src]="item.customIconDark" alt="icon"
                     class="icon-20 align-middle" matListItemIcon>
                <img *ngIf="themeService.getCurrentTheme() === 'dark' && !item.customIconDark" [src]="item.customIcon" alt="icon"
                     class="icon-20 align-middle" matListItemIcon>
            </ng-container>
            <span class="hide-menu">{{ item.displayName | localize }}</span>
        </mat-list-item>
    }

    <!-- children -->
    @if (expanded) {
        @for (child of item.children; track child) {
            <app-nav-item
                    [item]="child"
                    (click)="onSubItemSelected(child)"
                    [depth]="depth + 1"
            >
            </app-nav-item>
        }
    }
}
